module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/transfer/transfer.component.css
// module id = ./src/app/transfer/transfer.component.css
// module chunks = main